module.exports = __webpack_public_path__ + "img/device_icon.1ac6de07.svg";